import React from 'react';
import { Navigate, Outlet, useMatch } from 'react-router-dom';
import { useUserRoles } from '@hooks/useUserRoles.ts';
import { ROUTES } from '@router/constants.ts';
import { getAdminCenterContextFromToken } from '@routes/auth/___shared___/helpers.ts';
import { getAdminLandingPath, isTenantAdminOnly } from '@utils/roles.ts';

// Admin entry URLs (/admin, /admin/tenant-client: start page, bookmark, reload, role tab) open the own tenant
// of a Tenant Admin. It is decided here, before any admin page renders, so the client list is never shown first.
export const AdminLandingGuard: React.FC = () => {
    const userRoles = useUserRoles();
    const isAdminRoot = useMatch(`/${ROUTES.SIDEBAR.ADMIN.ROOT}`) !== null;
    const isClientList =
        useMatch(`/${ROUTES.SIDEBAR.ADMIN.ROOT}/${ROUTES.SIDEBAR.ADMIN.TENANT_CLIENT_ADMINISTRATION}`) !== null;

    if (!(isAdminRoot || isClientList) || !isTenantAdminOnly(userRoles)) {
        return <Outlet />;
    }

    const adminLandingPath = getAdminLandingPath({ userRoles, ...getAdminCenterContextFromToken() });

    // a token from before the backend added clientId gives /admin here, so the client list opens as before
    if (adminLandingPath === ROUTES.SIDEBAR.ADMIN.ROOT) {
        return <Outlet />;
    }

    return <Navigate to={`/${adminLandingPath}`} replace />;
};
